<template>
  <div
    class="header-banner d-flex flex-row justify-content-flex-start align-items-center mb-2"
  >
    <div class="image mx-3 my-2">
      <img :src="props.headerBannerImage" />
    </div>
    <div>
      <div class="title fs-6 lh-1 mb-2">
        <b>{{ props.headerBannerTitle }}</b>
      </div>
      <div class="sub-title fs-7 lh-1">
        <b>{{ props.headerBannerSubtitle }}</b>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">


interface Props {
  headerBannerImage: string;
  headerBannerTitle: string;
  headerBannerSubtitle: string;
}

const props = withDefaults(defineProps<Props>(), {
  headerBannerImage: "",
  headerBannerTitle: "",
  headerBannerSubtitle: "",
});
</script>

<style lang="scss" scoped>
@import "@/assets/scss/constants";
.header-banner {
  background-color: $pj-color-lighter-gray;

  .image {
    height: 80px;
  }
  .title {
    color: $pj-color-green;
    font-family: Inter;
  }
  .sub-title {
    color: var(--Typography-Text-2-ICON, #595a5a);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 21px;
  }
}
</style>
